module.exports = __webpack_public_path__ + "assets/closeCircle-cab4b5.svg";